import React from "react";

function StopIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10.146" height="10.146" viewBox="0 0 10.146 10.146">
        <path id="Icon_awesome-stop" data-name="Icon awesome-stop" d="M9.059,2.25H1.087A1.087,1.087,0,0,0,0,3.337v7.972A1.087,1.087,0,0,0,1.087,12.4H9.059a1.087,1.087,0,0,0,1.087-1.087V3.337A1.087,1.087,0,0,0,9.059,2.25Z" transform="translate(0 -2.25)" fill="#fff"/>
      </svg>
      
    );
}

export default StopIcon;



